import {ILoesungshaeufigkeitenWerte, IPortalseite, ISchueler_testsAPI, ITestheftAPI} from "../Interfaces";
import Utilities from "./../Utilities";
import {ISchuelerDB} from "../InterfacesDB";
import Rueckmeldung from "./Rueckmeldung";
import Tooltip, {TOOLTIP_INHALTE} from '../Tooltip';
import TooltipSchuelerergebnisse from '../TooltipSchuelerergebnisse';

interface IErgebnisspalte {
    kategorie: string;
    bezeichnung: string;
}

export default class RueckmeldungSchuelerebene extends Rueckmeldung implements IPortalseite {
    private tooltipSchuelerergebnisse: TooltipSchuelerergebnisse | null = null;

    override async onSeiteLoad(): Promise<boolean> {
        await super.onSeiteLoad();
        await this.filterAnwenden();
        this.refreshDruckkopf();

        //Spaltenköpfe einbinden und Sortierung initialisieren
        if (this.domaenenInGruppe.length === 0)
            return true;

        this.tooltipSchuelerergebnisse = new TooltipSchuelerergebnisse(this.testheftliste, this.testsInGruppe, this.schuelerliste, this.domaenenliste, this.tooltipItem, this.sessionvariablen.projekt.weiche ?? '', this.rmFilter.gruppeId, () => {
            this.tresor?.fillTresorLuecken();
        });

        const ergebnisspalten = this.getErgebnisspalten();
        const isVera5 = this.sessionvariablen.projekt.weiche === 'vera5';
        const schuelerebeneContainer = document.querySelector<HTMLDivElement>(`div.rueckmeldung-lh-schuelerebene`);
        schuelerebeneContainer?.classList.add(this.rmFilter.fach);
        if (isVera5 === true)
            schuelerebeneContainer?.classList.add('vera5');
        if (schuelerebeneContainer !== null) {
            schuelerebeneContainer.dataset.ergebnisspaltenAnzahl = ergebnisspalten.length.toString();
            schuelerebeneContainer.dataset.testheftvariantenAnzahl = this.rmFilter.testheftinformation.testhefte.length.toString();
            if (isVera5 === true)
                this.initVera5Itemvergleich(schuelerebeneContainer);
        }
        document.body.dataset.druckausrichtung = (ergebnisspalten.length + 1 < 3 && isVera5 === false) ? 'hochformat' : 'querformat';

        document.querySelector(`div.rueckmeldung-lh-schuelerebene > table > thead`).innerHTML = `
        <tr class="header">
            <th scope="col" class="schuelerinfos" data-sort-kategorie="schuelerinfo">Teilnehmer</th>
            ${ergebnisspalten.map(spalte => `<th scope="col" class="loesungshaeufigkeit ${spalte.kategorie}" data-sort-kategorie="${spalte.kategorie}">${spalte.bezeichnung}</th>`).join('')}
            ${(isVera5 === true) ? `<th scope="col" class="loesungsergebnisse">Lösungen</th>` : ``}
        </tr>
        `;

        await this.initSortierungSpaltenkoepfe();

        // initiale Sortierung anzeigen
        document.addEventListener('refresh-rueckmeldung', () => {
            this.refreshLhSchuelerebene();
        });
        document.dispatchEvent(new Event('refresh-rueckmeldung'));

        return true;
    }

    override async onSeiteFinished(): Promise<boolean> {
        return true;
    }

    private refreshLhSchuelerebene(): void {
        let testsInGruppe = Utilities.cloneObject(this.testsInGruppe) as ISchueler_testsAPI[];
        const ergebnisspalten = this.getErgebnisspalten();
        const isVera5 = this.sessionvariablen.projekt.weiche === 'vera5';
        const anzahlTabellenspalten = ergebnisspalten.length + ((isVera5 === true) ? 1 : 0);
        this.markiereVera5Item(null);

        //region Einträge nach ausgewählter Spalte sortieren
        let kategorie: string = document.querySelector(`[data-sort-kategorie][data-sort-richtung]`)?.getAttribute('data-sort-kategorie') ?? null;
        let richtung: string = document.querySelector(`[data-sort-kategorie][data-sort-richtung]`)?.getAttribute('data-sort-richtung') ?? null;

        if (kategorie === null || kategorie === 'schuelerinfo') {
            testsInGruppe.sort((a, b) => {
                return (
                    this.schuelerliste.filter((s) => s.schueler_id === a.schueler_id)[0].nr
                    <
                    this.schuelerliste.filter((s) => s.schueler_id === b.schueler_id)[0].nr
                ) ? -1 : 1;
            });
        }

        for (const column of ergebnisspalten.map(spalte => spalte.kategorie)) {
            if (kategorie !== column)
                continue;

            // Lösungshäufigkeit absteigend sortieren
            testsInGruppe
                .sort((a, b) => {
                    if (a.loesungshaeufigkeiten === null && b.loesungshaeufigkeiten === null) return 0;
                    if (a.loesungshaeufigkeiten === null) return -1;
                    if (b.loesungshaeufigkeiten === null) return 1;

                    if (a.nicht_anwesend === 1 && b.nicht_anwesend === 1) return 0;
                    if (a.nicht_anwesend === 1) return -1;
                    if (b.nicht_anwesend === 1) return 1;

                    let lhA: ILoesungshaeufigkeitenWerte = a.loesungshaeufigkeiten.insgesamt;
                    let lhB: ILoesungshaeufigkeitenWerte = b.loesungshaeufigkeiten.insgesamt;
                    if (column !== 'insgesamt') {
                        lhA = a.loesungshaeufigkeiten.domaenen.filter(d => d.name === column)[0].werte ?? null;
                        lhB = b.loesungshaeufigkeiten.domaenen.filter(d => d.name === column)[0].werte ?? null;
                    }

                    if (
                        (lhA.rProz * 100000 + lhA.nProz * 1000 + lhA.fProz) >
                        (lhB.rProz * 100000 + lhB.nProz * 1000 + lhB.fProz)
                    )
                        return 1;

                    if (
                        (lhA.rProz * 100000 + lhA.nProz * 1000 + lhA.fProz) <
                        (lhB.rProz * 100000 + lhB.nProz * 1000 + lhB.fProz)
                    )
                        return -1;

                    return 0;
                });
        }

        // Sortierung umkehren
        if (richtung === 'desc') {
            testsInGruppe.reverse();
        }
        //endregion

        //region Hinweistext einblenden, wenn Fach und Gruppe benötigt werden / niemand das Fach testet
        if (testsInGruppe.length === 0) {
            if (this.sessionvariablen.get['fach'] && this.sessionvariablen.get['gruppeid']) {
                document.querySelector(`div.rueckmeldung-lh-schuelerebene`).innerHTML =
                    `Keine Schüler
                        ${((this.gruppeAngezeigt.typ === 'STAMMKLASSE') ? 'der Stammklasse' : 'des Kurses') ?? 'der Gruppe'} <i>${this.gruppeAngezeigt.bezeichnung ?? ''}</i>
                        haben Ergebnisse im Fach ${Utilities.printFachLang(this.sessionvariablen.get['fach'])} eingetragen.
                        `;
            } else {
                document.querySelector(`div.rueckmeldung-lh-schuelerebene`).innerHTML = `Wählen Sie ein Fach und eine Gruppe aus, für die Sie Rückmeldungen einsehen möchten.`;
            }
            return;
        }
        //endregion

        //region Tabelle in DOM rendern
        document.querySelector(`div.rueckmeldung-lh-schuelerebene > table > tbody`)
            .innerHTML = testsInGruppe.map(test => {
            let schueler: ISchuelerDB = this.schuelerliste.filter((s) => s.schueler_id === test.schueler_id)[0] ?? null;
            let testheft: ITestheftAPI = this.testheftliste.filter(t => t.testheft_id === test.testheft_id)[0] ?? null;

            return `
            <tr class="schueler" data-nr="${schueler.nr}" data-schuelerid="${schueler.schueler_id}" data-testheftid="${testheft.testheft_id}">
                <th scope="row" class="schuelerinfos">
                    <div class="eigenschaften">
                        <span class="schuelerbezeichnung">Schüler${(schueler.geschlecht === 1) ? `` : (schueler.geschlecht === 2) ? `in` : `:in`}</span> <span class="nummer">${schueler.nr.toString().padStart(3, '0')}</span>
                        ${(schueler.geschlecht !== null) ? `
                        <span class="geschlecht">
                            <svg role="graphics-symbol">
                                <use href="/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#gender-${(schueler.geschlecht === 1) ? 'male' : (schueler.geschlecht === 2) ? 'female' : (schueler.geschlecht === 3) ? 'ambiguous' : 'null'}"/>
                            </svg>
                        </span>
                        ` : ``}
                        <span class="zusatzflags">
                            ${(schueler.is_f === 1) ? `<span data-tooltip="${TOOLTIP_INHALTE.sonderpaedagogischerFoerderbedarf}">F</span>` : ``}
                            ${(schueler.is_s === 1) ? `<span data-tooltip="${TOOLTIP_INHALTE.unzureichendeSprachbeherrschung}">S</span>` : ``}
                        </span>
                    </div>
                    <div class="klarname">
                        <span data-tresor-anzeige="schueler" data-nr="${schueler.nr}"></span>
                    </div>
                    <div class="testheft-bezeichnung" data-tooltip="${Tooltip.html`
                        <p><strong>Testheftvariante</strong></p>
                        <p>${testheft.bezeichnung}</p>
                    `}">
                        ${testheft.bezeichnung}
                    </div>
                </th>

            ${(test.loesungshaeufigkeiten === null && test.nicht_anwesend === 0) ? `
                    <td class="statusmeldung daten-unvollstaendig" colspan="${anzahlTabellenspalten}">Ergebnisdaten unvollständig
                    <span class="statusaktionen no-print">
                        <a class="statusaktion" href="/ergebnisdateneingabe.php?fach=${this.sessionvariablen.get['fach']}&gruppeid=${this.sessionvariablen.get['gruppeid']}&schuelernr=${schueler.nr}" aria-label="Ergebnisdaten vervollständigen" data-tooltip="${Tooltip.html`
                            <p><strong>Ergebnisdaten vervollständigen</strong></p>
                            <p>Vervollständigen Sie Ihre Eingaben in der Ergebnisdateneingabe und setzen Sie abwesende Schülerinnen und Schüler auf nicht anwesend.</p>
                        `}">
                            <svg role="graphics-symbol"><use href="/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#clipboard-check"/></svg>
                        </a>
                        <a class="statusaktion" href="/schuelerverwaltung.php?schuelerid=${schueler.schueler_id}" aria-label="Schülerstatus verwalten" data-tooltip="${Tooltip.html`
                            <p><strong>Schülerstatus verwalten</strong></p>
                            <p>Deaktivieren Sie Schülerinnen und Schüler, die nicht in dieser Stufe vorhanden sind, in der Schüler-Verwaltung.</p>
                        `}">
                            <svg role="graphics-symbol"><use href="/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#person-gear"/></svg>
                        </a>
                    </span>
                </td>` : ``}

            ${(test.nicht_anwesend === 1) ? `<td class="statusmeldung nicht-anwesend" colspan="${anzahlTabellenspalten}">Am Testtag abwesend</td>` : ``}

            ${(test.loesungshaeufigkeiten !== null && test.nicht_anwesend === 0) ? ergebnisspalten
                .map(spalte => {
                    const c = spalte.kategorie;
                    let lh: ILoesungshaeufigkeitenWerte = test.loesungshaeufigkeiten.insgesamt;
                    if (c !== 'insgesamt') {
                        lh = test.loesungshaeufigkeiten.domaenen.filter(d => d.name === c)[0].werte;
                    }

                    const getSegmentTooltip = (titel: string, anzahl: number, prozent: number): string => Tooltip.html`
                        <p><strong>${titel}</strong></p>
                        <p>${anzahl} von ${lh.anzahl} Items · <strong>${prozent} %</strong></p>
                    `;

                    return `
                    <td class="loesungshaeufigkeit ${c}">
                        <div class="lh-balkenspur gruppe detail" data-tooltip-schuelerergebnisse-test-id="${test.schueler_test_id}" data-tooltip-schuelerergebnisse-kategorie="${c}">
                            <span class="lh-balken-segment richtig" data-prozent="${lh.rProz}" style="width: ${lh.rProz}%" data-tooltip="${getSegmentTooltip('Richtig beantwortet', lh.r, lh.rProz)}"><span class="lh-balken-prozentwert">${lh.rProz}<span class="prozentzeichen">%</span></span></span>
                            <span class="lh-balken-segment nicht-bearbeitet" data-prozent="${lh.nProz}" style="width: ${lh.nProz}%" data-tooltip="${getSegmentTooltip('Nicht bearbeitet', lh.n, lh.nProz)}"><span class="lh-balken-prozentwert">${lh.nProz}<span class="prozentzeichen">%</span></span></span>
                            <span class="lh-balken-segment falsch" data-prozent="${lh.fProz}" style="width: ${lh.fProz}%" data-tooltip="${getSegmentTooltip('Falsch beantwortet', lh.f, lh.fProz)}"><span class="lh-balken-prozentwert">${lh.fProz}<span class="prozentzeichen">%</span></span></span>
                        </div>
                    </td>
                `;
                }).join('') : ``}
            ${(isVera5 === true && test.loesungshaeufigkeiten !== null && test.nicht_anwesend === 0) ? `<td class="loesungsergebnisse"><div class="vera5-item-ergebnisse">${this.renderVera5Itemergebnisse(test, testheft)}</div></td>` : ``}
            </tr>`
        }).join('');
        //endregion

        this.refreshBalkenbeschriftungen();

        if (this.tresor?.offen === true)
            this.tresor.fillTresorLuecken();
    }

    /** Liefert die sichtbaren Ergebnisspalten ohne redundante Gesamtspalte */
    private getErgebnisspalten(): IErgebnisspalte[] {
        const domaenenspalten = this.domaenenInGruppe.map(domaene => ({
            kategorie: domaene.domaene,
            bezeichnung: domaene.bezeichnung
        }));

        if (domaenenspalten.length === 1)
            return domaenenspalten;

        return [
            {kategorie: 'insgesamt', bezeichnung: 'Insgesamt'},
            ...domaenenspalten
        ];
    }

    /** Rendert die einzelnen Item-Ergebnisse in Testheftreihenfolge */
    private renderVera5Itemergebnisse(test: ISchueler_testsAPI, testheft: ITestheftAPI): string {
        const ergebnisseNachItem = new Map(test.ergebnisse.map(ergebnis => [ergebnis.item_id, ergebnis.ergebnis]));
        const renderItem = (item: ITestheftAPI['module'][number]['aufgaben'][number]['items'][number]): string => {
            const ergebnis = ergebnisseNachItem.get(item.item_id);
            const status = (ergebnis === 1) ? 'richtig' : (ergebnis === -1) ? 'nicht-bearbeitet' : (ergebnis === 0) ? 'falsch' : 'unbekannt';
            const kurzbezeichnung = (ergebnis === 1) ? 'R' : (ergebnis === -1) ? 'N' : (ergebnis === 0) ? 'F' : '?';
            const bezeichnung = (ergebnis === 1) ? 'Richtig gelöst' : (ergebnis === -1) ? 'Nicht bearbeitet' : (ergebnis === 0) ? 'Falsch gelöst' : 'Kein Ergebnis verfügbar';

            return `<span class="vera5-item-ergebnis ${status}" data-tooltip-item-id="${item.item_id}" data-tooltip-testheft-id="${testheft.testheft_id}" aria-label="${bezeichnung}">${kurzbezeichnung}</span>`;
        };

        const aufgaben = testheft.module.flatMap(modul => modul.aufgaben);
        if (testheft.fach !== 'de')
            return aufgaben.flatMap(aufgabe => aufgabe.items).map(renderItem).join('');

        return aufgaben.map(aufgabe => {
            const aufgabenname = aufgabe.bezeichnung.trim();
            const aufgabenkopf = (aufgabenname === '') ? '' : Tooltip.content`<div class="vera5-aufgabe-kopf"><span>${aufgabenname}</span></div>`;

            return `<div class="vera5-aufgabe-ergebnisse">${aufgabenkopf}<div class="vera5-aufgabe-items">${aufgabe.items.map(renderItem).join('')}</div></div>`;
        }).join('');
    }

    /** Hebt beim Überfahren eines Ergebnisses dasselbe Item in allen Schülerzeilen hervor */
    private initVera5Itemvergleich(container: HTMLDivElement): void {
        container.addEventListener('pointerover', event => {
            if (!(event.target instanceof Element))
                return;

            const item = event.target.closest<HTMLElement>('span.vera5-item-ergebnis');
            if (item === null || container.contains(item) === false)
                return;

            this.markiereVera5Item(item.dataset.tooltipItemId ?? null);
        });

        container.addEventListener('pointerout', event => {
            if (!(event.target instanceof Element))
                return;

            const item = event.target.closest<HTMLElement>('span.vera5-item-ergebnis');
            if (item === null || container.contains(item) === false)
                return;

            const naechstesItem = (event.relatedTarget instanceof Element)
                ? event.relatedTarget.closest<HTMLElement>('span.vera5-item-ergebnis')
                : null;
            if (naechstesItem?.dataset.tooltipItemId === item.dataset.tooltipItemId)
                return;

            this.markiereVera5Item(null);
        });
    }

    /** Setzt den visuellen Vergleichszustand für eine Item-ID */
    private markiereVera5Item(itemId: string | null): void {
        const container = document.querySelector<HTMLDivElement>('div.rueckmeldung-lh-schuelerebene.vera5');
        if (container === null)
            return;

        container.classList.toggle('itemvergleich-aktiv', itemId !== null);
        container.querySelectorAll<HTMLElement>('span.vera5-item-ergebnis').forEach(item => {
            item.classList.toggle('gleiches-item', itemId !== null && item.dataset.tooltipItemId === itemId);
        });
    }

    /** Aktualisiert die fachlichen Angaben und die Legende des Ausdrucks */
    private refreshDruckkopf(): void {
        const druckFach = document.querySelector<HTMLElement>(`#rueckmeldung-druckfach`);
        const druckGruppe = document.querySelector<HTMLElement>(`#rueckmeldung-druckgruppe`);
        const druckLegende = document.querySelector<HTMLElement>(`#rueckmeldung-drucklegende`);
        const fach = this.rmFilter?.fach ?? this.sessionvariablen.get['fach'] ?? null;

        if (druckFach !== null)
            druckFach.textContent = (fach === null || fach === 'alle') ? '' : Utilities.printFachLang(fach);
        if (druckGruppe !== null)
            druckGruppe.textContent = this.gruppeAngezeigt?.bezeichnung ?? '';
        if (druckLegende !== null)
            druckLegende.textContent = 'Balkensegmente von links: richtig · nicht bearbeitet · falsch.';
    }

}
